import React from "react";

export const Xing = () => {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 20C0 8.95431 8.95431 0 20 0C31.0457 0 40 8.95431 40 20C40 31.0457 31.0457 40 20 40C8.95431 40 0 31.0457 0 20Z"
        fill="white"
      />
      <path
        d="M14.5739 15.1597C14.4349 15.1597 14.318 15.2084 14.2593 15.3039C14.1984 15.4025 14.2079 15.5294 14.2724 15.6579L15.8326 18.3588C15.8352 18.3641 15.8352 18.3672 15.8326 18.3719L13.3808 22.6987C13.3168 22.8261 13.32 22.9541 13.3808 23.0527C13.4395 23.1476 13.5434 23.21 13.6824 23.21H15.9899C16.335 23.21 16.5013 22.9772 16.6193 22.7642C16.6193 22.7642 19.0171 18.5235 19.1104 18.3588C19.101 18.3436 17.524 15.5923 17.524 15.5923C17.4091 15.3878 17.2355 15.1597 16.8815 15.1597H14.5739Z"
        fill="#6C3BC7"
        fillOpacity="0.8"
      />
      <path
        d="M24.2683 12C23.9238 12 23.7743 12.2171 23.6505 12.4395C23.6505 12.4395 18.6793 21.2555 18.5156 21.545C18.524 21.5608 21.7945 27.5605 21.7945 27.5605C21.9088 27.765 22.0856 28 22.439 28H24.744C24.883 28 24.9916 27.9476 25.0503 27.8526C25.1117 27.754 25.1101 27.624 25.0456 27.496L21.7924 21.5524C21.7893 21.5477 21.7893 21.5419 21.7924 21.5372L26.9016 12.5035C26.9656 12.376 26.9672 12.246 26.9063 12.1474C26.8476 12.0524 26.7385 12 26.5995 12H24.2683Z"
        fill="#6C3BC7"
        fillOpacity="0.8"
      />
    </svg>
  );
};
